
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marca",
      function () {
        return require("private-next-pages/marca.js");
      }
    ]);
  